<template>
    <div class="reset-password-container">
        <div class="reset-password-box" v-if="!emailSent">
            <h2 class="reset-password-box__title" v-html="$t('ResetPassword.new_password')"></h2>
            <p class="reset-password-box__description" v-html="$t('ResetPassword.enter_email_info')"></p>
            <TotemInput type="text" :label="$t('ResetPassword.enter_your_email')" v-model="$v.model.email.$model" class="reset-password-box__input" />
            <totem-form-finnish-label-error class="error-label" :field="$v.model.email" :label="$t('General.email_address')"/>
            <TotemButton @click="sendResetPasswordRequest" class="reset-password-box__button" color="primary" :disabled="sendProcessed" :label="$t('ResetPassword.change_password')" />
            <div class="error" v-if="error">{{ error }}</div>
        </div>
        <div class="reset-password-box" v-if="emailSent">
            <h2 class="reset-password-box__title" v-html="$t('ResetPassword.change_password')"></h2>
            <p class="reset-password-box__description" v-html="$t('ResetPassword.check_email_info')"></p>
            <br>
            <p class="reset-password-box__description">
                <span v-html="$t('ResetPassword.contact')"></span>
                <span v-html="$t('ResetPassword.contact_url')"></span>
            </p>
        </div>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    const { required, email } = require('vuelidate/lib/validators')
    export default {
        name: 'reset-password',
        mixins: [ validationMixin ],
        methods: {
            async sendResetPasswordRequest (e) {
                this.error = null
                this.$v.$touch()
                if (this.$v.$invalid) {
                    e.preventDefault()
                } else {
                    try {
                        this.sendProcessed = true
                        await this.$store.dispatch('changePasswordRequest', this.model.email)
                        this.emailSent = true
                    } catch (e) {
                        this.sendProcessed = false
                        this.error = this.$t('General.bad_credentials')
                    }
                }
            }
        },
        validations: {
            model: {
                email: {
                    required,
                    email
                }
            }
        },
        data () {
            return {
                model: {
                    email: null,
                },
                error: null,
                emailSent: false,
                sendProcessed: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .reset-password-container {
        padding: 110px 0 100px !important;
    }
    
    .reset-password-box {
        max-width: 600px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        margin: 0 auto;

        &__button {
            align-self: flex-start;
            margin: 20px 0 0;
        }

        &__input {
            width: 100%;
        }

        &__title {
            padding: 0 0 20px 0;
            font-size: 2.4rem;
        }

        &__description {
            padding: 0 0 20px 0;
            font-size: 1.5rem;
            line-height: 150%;
        }
    }
    .error {
        color: red;
        align-self: center;
        padding: 10px;
        text-align: center;
    }
</style>
